<template>
  <div class="modal" id="modal-opportunities-list" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header pt-3">
          <h2 class="modal-title">{{ title }}</h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div><!-- /.modal-header -->

        <div class="modal-body p-0 overflow-visible">

          <ul v-if="opportunities.length > 0" class="list-data mb-0">
            <li v-for="opportunity in opportunities" :key="opportunity.id">
              <a @click="navigateToOpportunity(opportunity.id)">
                <div class="row">
                  <div class="col-12 col-lg-8 col-xl-8">
                    {{ opportunity.formatted_name }}
                  </div>
                  <div class="col-12 col-lg-4 col-xl-4 text-end">
                    <span v-bind:class="getStatusColor(opportunity.status)" class="status">{{ opportunity.status }}</span>
                  </div>
                </div>
              </a>
            </li>
          </ul>
          <div class="p-4" v-else>
            <p>No opportunities.</p>
          </div>
        </div><!-- /.modal-body -->
      </div>
    </div>
  </div><!-- /.modal -->
</template>

<script>
import { get, call } from 'vuex-pathify'
import { CModal, toast } from '@chameleon/chameleon-vue'

export default {
  extends: CModal,

  props: {
    title: {
      required: true,
    },
  },

  data () {
    return {
      opportunities: []
    }
  },

  computed: {
  },

  mounted () {
    this.addEventListener('open', async () => {

    })

    this.addEventListener('closed', () => {

    })
  },

  methods: {
    navigateToOpportunity(id) {
      this.close()
      this.$router.push({ name: 'opportunities.overview', params: { 'opportunity_id': id }})
    },

    getStatusColor(status) {
      switch (status) {
        case 'Draft':
          return "status-mute"
          break;
        case 'Sent':
          return "status-info"
          break;
        case 'Viewed':
          return "status-primary"
          break;
        case 'Declined':
          return "status-warning"
          break;
        case 'Signed':
          return "status-success"
          break;
        case 'Expired':
          return "status-danger"
          break;
      }
    },
  }
}
</script>
